import { PaySftLogo } from "./logo/logo";
import { PaySftPlainLogo } from "./logo/plain_logo"
import { ErrorIcon } from "./icons/error";
import { TickIcon } from "./icons/tick";
import { UserTickIcon } from "./icons/user-tick";
import { DocumentIcon, DocumentV2Icon, DocumentV3Icon } from "./icons/document";
import { UploadIcon,UploadV2Icon } from "./icons/upload";
import { LockIcon } from "./icons/lock";
import { DashboardIcon } from "./icons/sidebar/dashboard";
import { WalletIcon } from "./icons/sidebar/wallet";
import { TeamIcon,TeamMemberAddedIcon } from "./icons/sidebar/team";
import { AnalyticsIcon } from "./icons/sidebar/analytics";
import { BankIcon } from "./icons/sidebar/bank";
import { LeadsIcon } from "./icons/sidebar/leads";
import { SettingIcon } from "./icons/sidebar/setting";
import { InfoIcon } from "./icons/sidebar/info";
import { InquiriesIcon } from "./icons/sidebar/inquiries";
import { GalleryIcon } from "./icons/sidebar/gallery";
import { MedalIcon } from "./icons/medal";
import { SupportIcon, SupportV2Icon } from "./icons/support";
import { CrownIcon } from "./icons/crown";
import { ChevronDownIcon } from "./icons/chevron-down";
import {HouseIcon} from "./icons/house";
import { EditIcon, EditV2Icon } from "./icons/edit";
import { TrashIcon, TrashV2Icon, TrashV3Icon } from "./icons/trash";
import { MailIcon } from "./icons/mail";
import { PhoneIcon } from "./icons/phone";
import { PlusIcon } from "./icons/plus";
import { UserEditIcon } from "./icons/user-edit";
import { UserCrossIcon } from "./icons/user-cross";
import { LogoutIcon } from "./icons/logout";
import { NotificationIcon } from "./icons/notification";
import { ChevronLeftIcon } from "./icons/chevron-left";
import { ChevronRightIcon } from "./icons/chevron-right";
import { ChevronUpIcon } from "./icons/chevron-up";
import { FilterIcon } from "./icons/filter";
import { ArrowDownLeftIcon } from "./icons/arrow-down-left";
import { ArrowUpRightIcon } from "./icons/arrow-up-right";
import { CalendarIcon } from "./icons/calendar";
import { BedIcon, BathIcon, SizeIcon, KitchenIcon, BalconyIcon, SmartHomeIcon, ParkingIcon, TowersIcon, FloorsIcon, SingleTowerIcon} from "./icons/property-icons";
import { UpTrendIcon, DownTrendIcon } from "./icons/trend-icons";
import { MoneyIcon } from "./icons/money";
import { SearchIcon } from "./icons/search";
import { EyeIcon } from "./icons/eye";
import { RevenueIcon } from "./icons/revenue";
import { TokenPaymentIcon } from "./icons/token-payment";
import { PendingSettlementsIcon } from "./icons/pending-settlements";
import { StarIcon } from "./icons/star";
import { LocationIcon } from "./icons/location";
import { VerticalDotsIcon } from "./icons/vertical-dots";
import { DownloadIcon } from "./icons/download";
import { FolderIcon } from "./icons/folder";
import { ArchiveIcon } from "./icons/archive";
import {
    AmpleParkingIcon,
    CarParkingIcon,
    CentralACIcon,
    ConferenceRoomIcon,
    EvChargingIcon,
    FireSafetyIcon,
    GymFitIcon,
    HighSpeedElevatorIcon,
    LaundryIcon,
    PetCenterIcon,
    PowerBackupIcon,
    RainwaterHarvestingIcon,
    RestaurantIcon,
    Security24Icon,
    SewagePlantIcon,
    SolarPowerIcon,
    SportsClubIcon,
    SwimmingIcon,
    WaterSupplyIcon,
    WifiIcon,
} from "./icons/amenities";





export const Logo: Record<string, any> = {

    PaySftLogo: PaySftLogo,
    //PaySftPlainLogo: PaySftPlainLogo

}

export const Icons: Record<string, any> = {
    ErrorIcon: ErrorIcon,
    TickIcon: TickIcon,
    UserTickIcon: UserTickIcon,
    DocumentIcon: DocumentIcon,
    DocumentV2Icon: DocumentV2Icon,
    UploadIcon: UploadIcon,
    UploadV2Icon:UploadV2Icon,
    LockIcon: LockIcon,
    DashboardIcon: DashboardIcon,
    WalletIcon: WalletIcon,
    TeamIcon: TeamIcon,
    TeamMemberAddedIcon:TeamMemberAddedIcon,
    AnalyticsIcon: AnalyticsIcon,
    BankIcon: BankIcon,
    LeadsIcon: LeadsIcon,
    SettingIcon: SettingIcon,
    InfoIcon: InfoIcon,
    InquiriesIcon: InquiriesIcon,
    GalleryIcon: GalleryIcon,
    CrownIcon: CrownIcon,
    ChevronDownIcon: ChevronDownIcon,
    HouseIcon: HouseIcon,
    EditIcon: EditIcon,
    TrashIcon: TrashIcon,
    MailIcon: MailIcon,
    PhoneIcon: PhoneIcon,
    PlusIcon: PlusIcon,
    UserEditIcon: UserEditIcon,
    UserCrossIcon: UserCrossIcon,
    LogoutIcon: LogoutIcon,
    NotificationIcon: NotificationIcon,
    ChevronLeftIcon: ChevronLeftIcon,
    ChevronRightIcon: ChevronRightIcon,
    ChevronUpIcon: ChevronUpIcon,
    FilterIcon: FilterIcon,
    ArrowDownLeftIcon: ArrowDownLeftIcon,
    ArrowUpRightIcon: ArrowUpRightIcon,
    CalendarIcon: CalendarIcon,
    BedIcon: BedIcon,
    BathIcon: BathIcon,
    SizeIcon: SizeIcon,
    KitchenIcon: KitchenIcon,
    BalconyIcon: BalconyIcon,
    SmartHomeIcon: SmartHomeIcon,
    ParkingIcon: ParkingIcon,
    TowersIcon: TowersIcon,
    FloorsIcon: FloorsIcon,
    StarIcon: StarIcon,
    LocationIcon: LocationIcon,
    UpTrendIcon: UpTrendIcon,
    DownTrendIcon: DownTrendIcon,
    MoneyIcon: MoneyIcon,
    MedalIcon: MedalIcon,
    SupportIcon: SupportIcon,
    SearchIcon:SearchIcon,
    EyeIcon:EyeIcon,
    EditV2Icon:EditV2Icon,
    RevenueIcon: RevenueIcon,
    TokenPaymentIcon: TokenPaymentIcon,
    PendingSettlementsIcon: PendingSettlementsIcon,
    SupportV2Icon: SupportV2Icon,
    VerticalDotsIcon: VerticalDotsIcon,
    DownloadIcon: DownloadIcon,
    TrashV2Icon: TrashV2Icon,
    TrashV3Icon: TrashV3Icon,
    ArchiveIcon: ArchiveIcon,
    FolderIcon: FolderIcon,
    SingleTowerIcon: SingleTowerIcon,
    DocumentV3Icon: DocumentV3Icon,
    AmpleParkingIcon: AmpleParkingIcon,
    CarParkingIcon: CarParkingIcon,
    CentralACIcon: CentralACIcon,
    ConferenceRoomIcon: ConferenceRoomIcon,
    EvChargingIcon: EvChargingIcon,
    FireSafetyIcon: FireSafetyIcon,
    GymFitIcon: GymFitIcon,
    HighSpeedElevatorIcon: HighSpeedElevatorIcon,
    LaundryIcon: LaundryIcon,
    PetCenterIcon: PetCenterIcon,
    PowerBackupIcon: PowerBackupIcon,
    RainwaterHarvestingIcon: RainwaterHarvestingIcon,
    RestaurantIcon: RestaurantIcon,
    Security24Icon: Security24Icon,
    SewagePlantIcon: SewagePlantIcon,
    SolarPowerIcon: SolarPowerIcon,
    SportsClubIcon: SportsClubIcon,
    SwimmingIcon: SwimmingIcon,
    WaterSupplyIcon: WaterSupplyIcon,
    WifiIcon: WifiIcon,
}
